import { ClientFiles } from "./client-files";
import { header } from "./header";


jQuery(document).ready(() => {
    //Clear search
    jQuery(".clear_search").on("click", function () {
        var onlyUrl = window.location.href.replace(window.location.search, '');
        window.location.href = onlyUrl;
    });
    let headerSettings = new header;
    jQuery('.main-nav > .menu-item').on('mouseover', function () {

        let menu = this.getElementsByClassName('sub-menu')[0];
        let menuPosition = menu.getBoundingClientRect();
        let diff = (menuPosition.x + menuPosition.width) - (jQuery(window).width() - 20);
        if (diff > 0) {
            jQuery(menu as HTMLElement).css('left', "-" + (500 + diff) + "px" + " !important");
            jQuery(menu as HTMLElement).css('right', "-" + (500 - diff) + "px" + " !important");
            (menu as HTMLElement).style.setProperty('--left', diff + "px");
            (menu as HTMLElement).style.setProperty('--right', "-" + diff + "px");
        } else if ((diff = 0 - menuPosition.x) > 0) {
            jQuery(menu as HTMLElement).css('left', "-" + (500 - diff) + "px" + " !important");
            jQuery(menu as HTMLElement).css('right', "-" + (500 + diff) + "px" + " !important");
            (menu as HTMLElement).style.setProperty('--left', "-" + diff + "px");
            (menu as HTMLElement).style.setProperty('--right', diff + "px");
        }
    });

    let clientPages = new ClientFiles();



});

